module.exports = __webpack_public_path__ + "img/swift-code.09828947.png";